module.exports = __webpack_public_path__ + "img/sshx5.5a7c2d0d.png";